<template>
  <v-app class="iframe-app wallet">
    <v-toolbar flat class="iframe-header modal_header">
      <v-img
        height="37"
        max-width="140"
        contain
        class="wallid-logo"
        src="@/assets/logo-iframe.svg"
        alt="WallID Logo"
      />
    </v-toolbar>

    <ErrorBanner
      :errorMsg="errorMsg"
      class="mx-3"
      style="max-width:862px !important;"
    />
    <router-view @eventUpdate="eventUpdate" />
    <v-footer fixed v-if="step == 3" class="iframe-footer modal_footer">
      <v-container grid-list-md text-center>
        <v-layout justify-end>
          <v-btn
            id="sign"
            :disabled="signing"
            depressed
            width="110"
            @click="submitStep"
            class="advance button-iframe"
            >OK</v-btn
          >
        </v-layout>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import mixin from '@/plugins/mixin.js';

// Wallet flow routes
import { routes } from './WALLET/routes';
import ErrorBanner from '@/components/ErrorBanner';

import { EventBus } from '@/plugins/event-bus';

const { detect } = require('detect-browser');

const browser = detect();

const logger = {
  log: require('debug')('iframe:WALLET'),
  error: require('debug')('iframe:WALLET:error'),
};

export default {
  name: 'App',
  mixins: [mixin],
  components: {
    ErrorBanner,
  },
  watch: {
    async walletAddress(newVal, oldVal) {
      logger.log('walletAddress', newVal, oldVal);

      if (!newVal) {
        this.clearWallet();
      }

      if (newVal != oldVal && !this.hasAssets) {
        const { level } = await this.callConnectWallet();
        logger.log('level', level);

        if (level > 1) {
          const assets = await this.getListAssets();
          this.handleAssets(assets);

          this.errorMsgStatus = '';
          this.$store.commit('loading', false);
        }
      }
    },
    hasAssets(newVal, oldVal) {
      logger.log('hasAssets', newVal, oldVal);

      // if (this.$route.path == '/') {
      //   this.$router.push('/Identity');
      // }
    },
  },
  async created() {
    // Create routes constants
    Object.keys(routes).forEach((cName) => (this[cName] = routes[cName]));

    // if (
    //   localStorage.getItem('checkWallet') &&
    //   localStorage.getItem('checkWallet') == 'Onboarding'
    // ) {
    //   this.errorMsgStatus = 'noIdentitiesTimed';
    //   window.onfocus = this.onFocusCheckWeb3;
    // }
    this.$i18n.locale = 'en'; // this.getBrowserLocales({ languageCodeOnly: true })[0];
    // this.setupIntercom();
    switch (browser && browser.name) {
      case 'chrome':
        this.activateWallidPlugin();
        break;
      default:
        this.$store.commit('loading', false);
        this.errorMsg = 'noComp';
        this.snackbar = true;
      // this.eventUpdate({
      //   time: 1,
      //   params: {
      //     user_id: window.Intercom("getVisitorId"),
      //     msg: this.$i18n.t("intercom.compatible")
      //   }
      // });
    }
  },
  async mounted() {},

  computed: {
    ...mapGetters([
      'terms',
      'step',
      'password',
      'verify',
      'signing',
      'dropdown_identity',
      'loading',
      'hasAssets',
    ]),
    ...mapGetters('plugin', ['isOnboardingComplete']),

    ...mapState('plugin', {
      walletAddress: 'walletAddress',
      hasPlugin: 'hasPlugin',
    }),

    errorMsgStatus: {
      get() {
        return this.$store.state.errorMsgStatus;
      },
      set(newValue) {
        return this.$store.commit('errorMsgStatus', newValue);
      },
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(newValue) {
        return this.$store.commit('snackbar', newValue);
      },
    },
    idt: {
      get() {
        return this.$store.state.idt;
      },
      set(newValue) {
        return this.$store.commit('idt', newValue);
      },
    },
    errorMsg: {
      get() {
        return this.$store.state.errorMsg;
      },
      set(newValue) {
        return this.$store.commit('errorMsg', newValue);
      },
    },
    isDisabled: function() {
      return this.idt == '';
    },
  },
  methods: {
    ...mapActions('plugin', {
      getWalletAddress: 'wallet_address',
      getOnboardingComplete: 'wallid_onboarding',
      getListAssets: 'wallid_list',
      callConnectWallet: 'wallid_connect',
    }),

    ...mapActions({
      handleAssets: 'HANDLE_ASSETS',
    }),

    setupIntercom() {
      let lang = navigator.language.substring(0, 2);

      window.intercomSettings = {
        alignment: 'left',
        vertical_padding: 70,
        app_id: 'wad8d6ha',
        language_override: lang,
        custom_launcher_selector: '#my_custom_link',
        hide_default_launcher: true,
      };

      (function() {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === 'function') {
          ic('reattach_activator');
          ic('update', w.intercomSettings);
        } else {
          var d = document;
          var i = function() {
            i.c(arguments);
          };
          i.q = [];
          i.c = function(args) {
            i.q.push(args);
          };
          w.Intercom = i;
          var l = function() {
            var s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/wad8d6ha';
            var x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          };
          if (w.attachEvent) {
            w.attachEvent('onload', l);
          } else {
            w.addEventListener('load', l, false);
          }
        }
      })();
    },
    // onFocusCheckIDS() {
    //   if (this.hasPlugin) {
    //     this.getIdentitiesPlugin();
    //   }

    //   // this.errorMsgStatus = 'noIdentitiesTimed';
    // },

    eventUpdate(e) {
      EventBus.$emit('eventUpdate', e);
    },
    clearWallet() {
      this.$store.commit('plugin/walletAddress', null);

      this.checkWallet();
    },
    checkWallet() {
      this.eventUpdate({
        time: 30,
        params: {
          msg: this.$i18n.t('intercom.start'),
        },
      });
      logger.log('this.walletAddress', this.walletAddress);

      if (this.walletAddress) {
        this.errorMsgStatus = '';
        this.snackbar = false;
        if (!this.hasAssets) {
          this.$store.commit('loading', true);
          if (this.hasPlugin) {
            this.getIdentitiesPlugin();
          }
        }
        // if (this.$route.path != "/") {
        //   this.$router.push("/");
        // }
      } else if (!this.walletAddress) {
        this.errorMsgStatus = 'loggedOut';
        this.snackbar = true;
        this.$store.commit('loading', false);
        if (this.$route.path != '/') {
          this.$store.commit('step', 0);
          this.$router.push(this.ROUTE_HOME);
        }
      }
    },
    async initializePlugin() {
      logger.log('activate Wallid Plugin', this.WALLID);
      this.$store.commit('plugin/hasPlugin', true);
      try {
        const isOnboardingComplete = await this.getOnboardingComplete();
        this.errorMsgStatus = 'notConnected';
        logger.log('isOnboardingComplete', isOnboardingComplete);

        // window.onfocus = null;

        logger.log('Has Wallid plugin, starting listeners');
        document.addEventListener('wallid_event_lock', this.clearWallet);
        document.addEventListener('wallid_event_unlock', async () => {
          if (!this.wallet) {
            await this.initializePlugin();
          }
        });
        const { isLocked, notConnected } = await this.getWalletAddress();

        logger.log('isLocked', isLocked);
        if (isLocked) {
          this.errorMsgStatus = 'loggedOut';
          throw { errorStatus: 'ERR_PLUGIN_LOCKED' };
        }
        if (notConnected) {
          this.errorMsgStatus = 'notConnected';
          throw { errorStatus: 'ERR_NO_PERMISSION' };
        }

        // So far so good, turn off loading wall and clear errors
        this.errorMsgStatus = null;
        // this.$store.commit('loading', false);
      } catch (error) {
        logger.error(error);
        this.$store.commit('loading', false);
        this.errorMsgStatus = error.errorStatus;
        // await this.callConnectWallet();
        // this.initializePlugin();
        // if (error === 'ERR_PLUGIN_LOCKED') {
        //   await this.callConnectWallet();
        // }
      }
    },

    async activateWallidPlugin() {
      const { wallid } = window;

      if (wallid) {
        this.initializePlugin();
      } else {
        document.addEventListener('wallid_event_ready', this.initializePlugin);
        // if (
        //   localStorage.getItem('checkWallet') &&
        //   localStorage.getItem('checkWallet') == 'Onboarding'
        // ) {
        //   this.errorMsgStatus = 'noIdentitiesTimed';
        // } else {
        localStorage.setItem('checkWallet', 'noWalletInstalled');
        this.errorMsgStatus = 'noWallet';
        // }
        this.$store.commit('loading', false);
        this.snackbar = true;
        this.$store.commit('showIdentitiesStatus');

        this.eventUpdate({
          time: 30,
          params: {
            msg: this.$i18n.t('intercom.wallet'),
          },
        });
      }
    },
    submitStep() {
      logger.log('Method submitStep');
      this.snackbar = false;
      this.errorMsg = '';
      this.errorMsgStatus = '';
      logger.log(this.$store.getters.step);

      switch (this.$store.getters.step) {
        case 1:
          this.$eventHub.$emit('identity-event');
          break;
        case 2:
          this.$store.commit('verify', true);
          this.$eventHub.$emit('verify-event');
          break;
        case 3:
          var url_red = this.$store.getters.redirectUrl;
          logger.log('redirect_url ' + url_red);
          if (url_red) {
            window.location.replace(url_red);
          }
          break;
        default:
          break;
      }
    },

    cancelSign() {
      this.$store.commit('idt', '');
      this.$store.commit('step', 0);
      this.$store.commit('terms', false);
      this.$router.push(this.ROUTE_HOME);
      this.snackbar = false;
    },
  },
  data() {
    return {
      intercomIcon: require('@/assets/icon-intercom-iframe.svg'),
      langs: [
        { id: 'pt', name: 'Português' },
        { id: 'en', name: 'English' },
      ],
    };
  },
};
</script>
<style lang="scss" src="@/styles/iframe.scss"></style>
